import styled from 'styled-components'

export const tabTransformacaoStyles = {
  Container: styled.div`
    margin: 16px;
  `
}
